import { IconProps } from "../types/icon";

export const CloudSnowIcon = ({
  className = "",
  size = 16,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      viewBox="0 0 16 16"
    >
      <g fill={color}>
        <path d="M.5 8.4C.2 7.6 0 6.8 0 6c0-3.3 2.7-6 6-6 2.6 0 4.8 1.6 5.6 4C14 3.8 16 5.7 16 8c0 .6-.4 1-1 1s-1-.4-1-1c0-1.3-1.3-2.4-2.7-1.9-.6.3-1.3-.1-1.4-.7C9.6 3.4 8 2 6 2 3.8 2 2 3.8 2 6c0 .6.1 1.1.3 1.6s0 1.1-.5 1.3-1.1 0-1.3-.5M9 14H7v2h2zM6 12H4v2h2zM12 12h-2v2h2zM9 10H7v2h2z" />
        <path d="M6 8H4v2h2zM12 8h-2v2h2z" />
      </g>
    </svg>
  );
};
